import { Injectable, signal, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type ThemeMode = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  readonly mode = signal<ThemeMode>(this.resolveInitialMode());

  constructor() {
    effect(() => this.applyTheme(this.mode()));
  }

  toggle(): void {
    this.mode.set(this.mode() === 'light' ? 'dark' : 'light');
    localStorage.setItem('theme', this.mode());
  }

  private resolveInitialMode(): ThemeMode {
    const stored = localStorage.getItem('theme') as ThemeMode | null;
    if (stored) return stored;
    return globalThis.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  private applyTheme(mode: ThemeMode): void {
    this.document.documentElement.classList.toggle('dark', mode === 'dark');
  }
}
